import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationWaterfallChartIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "rect",
    {
      x: "64",
      y: "888",
      width: "896",
      height: "72",
      rx: "32",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M128 236C128 218.327 142.327 204 160 204H244C261.673 204 276 218.327 276 236V784C276 801.673 261.673 816 244 816H160C142.327 816 128 801.673 128 784V236Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M748 516C748 498.327 762.327 484 780 484H864C881.673 484 896 498.327 896 516V784C896 801.673 881.673 816 864 816H780C762.327 816 748 801.673 748 784V516Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M283 96C283 78.3269 297.327 64 315 64H399C416.673 64 431 78.3269 431 96V172C431 189.673 416.673 204 399 204H315C297.327 204 283 189.673 283 172V96Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M438 236C438 218.327 452.327 204 470 204H554C571.673 204 586 218.327 586 236V312C586 329.673 571.673 344 554 344H470C452.327 344 438 329.673 438 312V236Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M593 376C593 358.327 607.327 344 625 344H709C726.673 344 741 358.327 741 376V452C741 469.673 726.673 484 709 484H625C607.327 484 593 469.673 593 452V376Z",
      fill: "#5CBAEB"
    }
  )
] });
export {
  VisualisationWaterfallChartIcon
};
